import DownloadLink from './default'

export default DownloadLink
